import React, {
  useContext,
  useEffect,
} from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';
import {
  Button,
  Layout,
} from 'antd';

import { withRouter } from '../../hooks/withRouter';
import PageHeaderBar from '../../components/PageHeaderBar';
import User from '../../components/User';
import DeleteUser from '../../components/DeleteUser';
import Context from '../../context';
import UsersTable from '../../components/UsersTable';
import { PERMISSIONS } from '../../constants/users';
import { userHasPermission } from '../../utils/userHelpers';

const Users = ({ navigate }) => {
  const context = useContext(Context);
  const {
    isAdminAsMarketParty,
    isReadOnlyAdminAsMarketParty,
    isAdmin,
    users,
    updateUsers,
    selectedMarketPartyId,
  } = context;
  const { t } = useTranslation();

  useEffect(() => {
    updateUsers();
  }, [selectedMarketPartyId]);

  const handleButtonClick = () => {
    navigate('/users/new-user');
  };

  const renderNewUserButton = () => (
    (selectedMarketPartyId !== 'admin' && (isAdminAsMarketParty() || !isReadOnlyAdminAsMarketParty()))
      ? (
        <Button
          className="page__header__buttons__new-user"
          type="primary"
          onClick={handleButtonClick}
        >
          {t('common.button.addNewUser')}
        </Button>
      )
      : null
  );

  const renderEditUserRoute = () => (
    (isAdmin(true) || userHasPermission(context, [PERMISSIONS.ADMIN]))
      ? (
        <Routes>
          <Route
            path=":id"
            element={<User users={users} />}
          />
        </Routes>
      )
      : null
  );


  return (
    <>
      <PageHeaderBar
        title={t('app.menu.users')}
        actionItems={renderNewUserButton()}
      />
      <Layout.Content className="layout__container__page__content">
        <UsersTable />
        <Routes>
          <Route
            path="delete/:marketPartyId/:id"
            Component={DeleteUser}
          />
        </Routes>
        { renderEditUserRoute() }
      </Layout.Content>
    </>
  );
};

Users.propTypes = {
  navigate: PropTypes.func.isRequired,
};
Users.displayName = 'Users';

export default withRouter(Users);
export {
  Users as PureComponent,
};
